import axios from "axios";

const hoursAdminList = [
  "rolin@adelphi.edu",
  "cscala@adelphi.edu",
  "hfarahani@adelphi.edu",
  "yigarcia@adelphi.edu",
  "ckatz@adelphi.edu",
  "edinda@adelphi.edu",
];

function fetchUserEmail() {
  return axios
    .get("./remote-apis/user-api.php?cmd=professional")
    .then((response) => {
      return response.data.ROOT.Directory_SS.AUEmail;
    });
}

function isUserAuthorized(email) {
  return hoursAdminList.includes(email);
}

function fetchAuthenticatedUsers() {
  return axios
    .get(
      `${process.env.VUE_APP_API_BASE_URL}/v1/department_schedule_user/?no_pagination=true`
    )
    .then((response) => {
      return response;
    });
}

export async function checkHoursManagerUser() {
  try {
    const userEmail = await fetchUserEmail();
    // window.console.log("the userEmail is this",  userEmail);
    if (isUserAuthorized(userEmail)) {
      sessionStorage.setItem("isAdmin", true);
      sessionStorage.setItem("userDepartments", JSON.stringify([]));
    } else {
      try {
        const response = await fetchAuthenticatedUsers();
        const match = response.data.find((res) => res.email === userEmail);
        window.console.log("the match data is ",response,  match);

        if (match) {
          sessionStorage.setItem("isAdmin", false);
          sessionStorage.setItem(
            "userDepartments",
            JSON.stringify(match.department_codes)
          );
        } else {
          sessionStorage.setItem("isAdmin", false);
          sessionStorage.setItem("userDepartments", JSON.stringify(null));
        }
      } catch (error) {
        window.console.error(
          "There was an error fetching authenticated users:",
          error
        );
        sessionStorage.setItem("isAdmin", false);
        sessionStorage.setItem("userDepartments", JSON.stringify(null));
      }
    }
  } catch (error) {
    sessionStorage.setItem("isAdmin", false);
    sessionStorage.setItem("userDepartments", JSON.stringify(null));
    window.console.error("There was an error fetching the user email:", error);
  }
}
